import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5" }
const _hoisted_2 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3" }
const _hoisted_3 = { "data-testid": "doctor-crm-name" }
const _hoisted_4 = { "data-testid": "doctor-crm-number" }
const _hoisted_5 = {
  key: 0,
  class: "pt-5 border-t border-gray-100"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 mb-3" }, "CRMs do médico", -1)
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_9 = {
  key: 0,
  "data-testid": "doctor-crm-main-badge",
  class: "inline-flex items-center rounded-full bg-primary5 border border-primary px-2 py-0.5 text-xs font-medium text-primary"
}
const _hoisted_10 = {
  key: 1,
  class: "text-xs text-gray-500 ml-auto"
}
const _hoisted_11 = {
  key: 1,
  class: "pt-5 border-t border-gray-100"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 mb-3" }, "Especialidades", -1)
const _hoisted_13 = { class: "flex flex-wrap gap-2" }
const _hoisted_14 = { class: "text-sm font-medium text-textPrimary" }
const _hoisted_15 = {
  key: 0,
  class: "text-xs text-primary/80 border-l border-primary/30 pl-2"
}

import { computed } from 'vue'
import {
  mdiAccountOutline,
  mdiCardAccountDetailsOutline,
  mdiCheckDecagramOutline,
  mdiBadgeAccountOutline,
  mdiStethoscope
} from '@mdi/js'

import type { DoctorDetailResponse } from '@/Network/Types/Responses/CompanyResponses'
import type { DoctorCrmResponse } from '@/Network/Types/Responses/DoctorCrmResponses'
import DetailCard from '../atoms/DetailCard.vue'
import DetailField from '../atoms/DetailField.vue'
import { toTitleCase } from '../../helpers/doctorStatus'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfessionalDataPanel',
  props: {
    doctor: {},
    crms: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;



const crmName = computed(() => toTitleCase(props.doctor.doctor.mainCrm.name))

const hasMultipleCrms = computed(() => props.crms.length > 1)

const hasSpecialties = computed(
  () =>
    props.doctor.doctor.mainCrm.doctorSpecialties &&
    props.doctor.doctor.mainCrm.doctorSpecialties.length > 0
)

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DetailCard, { title: "Dados profissionais" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DetailField, {
            icon: _unref(mdiAccountOutline),
            label: "Nome registrado no CRM"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(crmName.value || '—'), 1)
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(DetailField, {
            icon: _unref(mdiCardAccountDetailsOutline),
            label: "Número do CRM"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.doctor.doctor.mainCrm.number) + "-" + _toDisplayString(_ctx.doctor.doctor.mainCrm.uf), 1)
            ]),
            _: 1
          }, 8, ["icon"]),
          (_ctx.doctor.doctor.mainCrm.status)
            ? (_openBlock(), _createBlock(DetailField, {
                key: 0,
                icon: _unref(mdiCheckDecagramOutline),
                label: "Status do CRM"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.doctor.doctor.mainCrm.status), 1)
                ]),
                _: 1
              }, 8, ["icon"]))
            : _createCommentVNode("", true),
          (_ctx.doctor.doctor.mainCrm.type)
            ? (_openBlock(), _createBlock(DetailField, {
                key: 1,
                icon: _unref(mdiBadgeAccountOutline),
                label: "Tipo do CRM"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.doctor.doctor.mainCrm.type), 1)
                ]),
                _: 1
              }, 8, ["icon"]))
            : _createCommentVNode("", true)
        ]),
        (hasMultipleCrms.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crms, (crm) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: crm.id,
                    "data-testid": "doctor-crm-item",
                    class: "flex flex-wrap items-center gap-2 rounded-xl border border-gray-100 bg-gray-50 px-4 py-2.5"
                  }, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(crm.number) + "-" + _toDisplayString(crm.uf), 1),
                    (crm.isMain)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Principal "))
                      : _createCommentVNode("", true),
                    (crm.status)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(crm.status), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (hasSpecialties.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctor.doctor.mainCrm.doctorSpecialties, (doctorSpecialty) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: doctorSpecialty.id,
                    class: "inline-flex items-center gap-2 rounded-lg border border-primary bg-primary5 px-3 py-1.5"
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(mdiStethoscope)), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(doctorSpecialty.specialty.name), 1),
                    (doctorSpecialty.rqe)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " RQE " + _toDisplayString(doctorSpecialty.rqe), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})